/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 17/03/22
 */

import React from 'react';

import GlobalAdminEditor from '@/components/pages/Admin/Global/GlobalAdminEditor';
import { SimpleGrid } from '@chakra-ui/react';

import TrimUploadPDF from '@/components/pages/Admin/Global/TrimUploadPDF';
import NeoImport from '@/components/pages/Admin/NeoImport/NeoImport';
import UploadHolidays from '@/components/pages/Admin/UploadHolidays/UploadHolidays';
import FacultyOrganisationEditor from '@/components/pages/Admin/Faculty/FacultyOrganisationEditor';

export const GlobalAdminPanel = () => {
    return (
        <SimpleGrid columns={3} gap={3}>
            <GlobalAdminEditor />
            <NeoImport />
            <FacultyOrganisationEditor />
            <UploadHolidays />
            <TrimUploadPDF />
        </SimpleGrid>
    );
};
